<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-10">
          <sign-up-form/>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SignUpForm from '@/components/SignUpForm.vue';
import { mapActions } from "vuex";

export default {
  components: { SignUpForm },
  name: "SignUp",
  mounted() {
    this.updateWindowTitle({newTitle: 'Sign Up'})
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
  },
};
</script>

<style></style>
